module.exports = __webpack_public_path__ + "img/logo.119d43f1.svg";